// extracted by mini-css-extract-plugin
export default {"api_dev_provider":"apiDevProvider_api_dev_provider__oVSKv","header":"apiDevProvider_header__7WqQH","list":"apiDevProvider_list__q5W51","delete":"apiDevProvider_delete__xgZvG"};